import { Pipe, PipeTransform } from '@angular/core';
import { StatusEnum } from '@ose/enums';

@Pipe({
  name: 'statusClass',
  standalone: true,
  pure: true,
})
export class StatusClassPipe implements PipeTransform {
  transform(status: StatusEnum | string | null | undefined): string {
    switch (status) {
      case StatusEnum.SUCCEED:
      case StatusEnum.CONFIRMED:
        return 'bg-success-subtle text-success-emphasis border border-success';

      case StatusEnum.PENDING:
      case StatusEnum.WAITING:
        return 'bg-warning-subtle text-warning-emphasis border border-warning-subtle';

      case StatusEnum.EXPIRED:
      case StatusEnum.FAILED:
      case StatusEnum.REJECTED:
      case StatusEnum.CANCELED:
        return 'bg-danger-subtle text-danger-emphasis border border-danger-subtle';

      default:
        return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
    }
  }
}
